<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-0 pb-0">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>RAPIDi Case Reports</a></div>
    </div>
  </div>
</div>
<div class="bg-default px-3 pb-3">
  <div class="card">
    <p-tabView (onChange)="switchHeaders($event);">
      <p-tabPanel header="ACTIVATION TIME INTERVAL" class="relative">
        <div class="grid chartpdf-btnn justify-content-end">
          <p-button type="button" icon="pi pi-chart-line" (click)="showChart('ACTIVATION TIME INTERVAL')"
            [ngStyle]="showChartBool?{'pointer-events': 'none'} : {'pointer-events': 'all'}" [disabled]="showChartBool"
            label="Graph Outliers" class="p-button-primary mr-1 p-0"></p-button>
        </div>
        <p-table #dt [value]="activationTimeList" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines"
          [paginator]="true" sortMode="multiple" [lazy]="true" responsiveLayout="scroll" [rowHover]="true" dataKey="Id"
          [totalRecords]="activationTotalRecords" [columns]="cols" (onLazyLoad)="lazyLoadSchedules($event)" [resizableColumns]="true" columnResizeMode="expand"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,15,25,50,activationTotalRecords]" >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="TeleCareCase#" pResizableColumn style="width:9%">
                TeleCare Case #
                <p-sortIcon field="TeleCareCase#"></p-sortIcon></th>
              <th pSortableColumn="FacilityName" pResizableColumn>
                Facility
                <p-sortIcon field="FacilityName"></p-sortIcon>
              </th>
              <th pSortableColumn="DateofConsult" pResizableColumn>
                Date of Consult
                <p-sortIcon field="DateofConsult"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationType" pResizableColumn>
                Identification Type
                <p-sortIcon field="IdentificationType"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationNumber" pResizableColumn>
                Identification Number
                <p-sortIcon field="IdentificationNumber"></p-sortIcon>
              </th>
              <th pSortableColumn="WorkFlowType" pResizableColumn>
                WorkFlow Type
                <p-sortIcon field="WorkFlowType"></p-sortIcon>
              </th>
              <th pSortableColumn="ActivationTimeInterval" pResizableColumn>
                Activation Time Interval
                <p-sortIcon field="ActivationTimeInterval"></p-sortIcon>
              </th>
              <th pSortableColumn="InitialAssesment" pResizableColumn>
                Initial Assesment
                <p-sortIcon field="InitialAssesment"></p-sortIcon>                
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-activationTimeList>
            <tr>
              <td>
              <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{activationTimeList.cas_case_number}}</ng-container>
              <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
                <a [href]="accessCase + activationTimeList.cas_key + showPopupOnLoad" target="_blank">{{activationTimeList.cas_case_number}}</a>
              </ng-container>
            </td>
              <td>{{activationTimeList.Facility}}</td>
              <td>{{activationTimeList.DateofConsult}}</td>
              <td>{{activationTimeList.IdentificationType}}</td>
              <td>{{activationTimeList.cas_identification_number}}</td>
              <td>{{activationTimeList.WorkFlowType}}</td>
              <td>{{activationTimeList.ActivationTimeInterval}}</td>
              <td><ul class="intial-li"><li *ngFor="let initialAssesment of activationTimeList.Initial_Assesment">{{initialAssesment}}</li></ul></td>


            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="activationTotalRecords==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="ASSESSMENT TIME INTERVAL" class="relative">
        <!-- ////////////////////////////////////////ASSESSMENT TIME INTERVAL////////////////////////////////////////////////// -->
        <div class="grid chartpdf-btnn justify-content-end">
          <p-button type="button" icon="pi pi-chart-line" (click)="showChart('ASSESSMENT TIME INTERVAL')"
            [ngStyle]="showChartBool?{'pointer-events': 'none'} : {'pointer-events': 'all'}" [disabled]="showChartBool"
            label="Graph Outliers" class="p-button-primary mr-1"></p-button>
        </div>
        <p-table #dt [value]=" assessmentTimeList" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines"
          [paginator]="true" sortMode="multiple" [lazy]="true" responsiveLayout="scroll" [rowHover]="true" dataKey="Id"
          [totalRecords]="assesmentTotalRecords" [columns]="cols" (onLazyLoad)="lazyLoadSchedules($event)" [resizableColumns]="true" columnResizeMode="expand"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,15,25,50,assesmentTotalRecords]">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="TeleCareCase#" pResizableColumn style="width:9%">
                TeleCare Case #
                <p-sortIcon field="TeleCareCase#"></p-sortIcon>
              </th>
              <th pSortableColumn="FacilityName" pResizableColumn>
                Facility
                <p-sortIcon field="FacilityName"></p-sortIcon>
              </th>
              <th pSortableColumn="DateofConsult" pResizableColumn>
                Date of Consult
                <p-sortIcon field="DateofConsult"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationType" pResizableColumn>
                Identification Type
                <p-sortIcon field="IdentificationType"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationNumber" pResizableColumn>
                Identification Number
                <p-sortIcon field="IdentificationNumber"></p-sortIcon>
              </th>
              <th pSortableColumn="WorkFlowType" pResizableColumn>
                WorkFlow Type
                <p-sortIcon field="WorkFlowType"></p-sortIcon>
              </th>
              <th pSortableColumn="AssessmentTimeInterval" pResizableColumn>
                Assessment Time Interval
                <p-sortIcon field="AssessmentTimeInterval"></p-sortIcon>
              </th>
              <th pSortableColumn="InitialAssesment" pResizableColumn>
                Initial Assesment
                <p-sortIcon field="InitialAssesment"></p-sortIcon></th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-assessmentTimeList>
            <tr>
              <td>
                <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{assessmentTimeList.cas_case_number}}</ng-container>
                <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
                  <a [href]="accessCase + assessmentTimeList.cas_key + showPopupOnLoad" target="_blank">{{assessmentTimeList.cas_case_number}}</a>
                </ng-container>
              </td>
              <!-- <td><a href={{accessCase}}{{assessmentTimeList.cas_key}}{{showPopupOnLoad}} target="_blank">{{assessmentTimeList.cas_case_number}}</a></td> -->
              <td>{{assessmentTimeList.Facility}}</td>
              <td>{{assessmentTimeList.DateofConsult}}</td>
              <td>{{assessmentTimeList.IdentificationType}}</td>
              <td>{{assessmentTimeList.cas_identification_number}}</td>
              <td>{{assessmentTimeList.WorkFlowType}}</td>
              <td>{{assessmentTimeList.AssessmentTimeInterval}}</td>
              <td><ul class="intial-li"><li *ngFor="let initialAssesment of assessmentTimeList.Initial_Assesment">{{initialAssesment}}</li></ul></td>


            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="assesmentTotalRecords==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="THROMBOLYTIC DECISION TIME INTERVAL" class="relative">
        <!-- ///////////////////////////////////////THROMBOLYTIC DECISION TIME INTERVAL////////////////////////////////////////////////// -->
        <div class="grid chartpdf-btnn justify-content-end">
          <p-button type="button" icon="pi pi-chart-line" (click)="showChart('THROMBOLYTIC DECISION TIME INTERVAL')"
            [ngStyle]="showChartBool?{'pointer-events': 'none'} : {'pointer-events': 'all'}" [disabled]="showChartBool"
            label="Graph Outliers" class="p-button-primary mr-1"></p-button>
        </div>
        <p-table #dt [value]=" thrombolyticDecisionTimeList" [rows]="rows"
          styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" sortMode="multiple" [lazy]="true"
          responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="thrombolyticDecisionTotalRecords"
          [columns]="cols" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          (onLazyLoad)="lazyLoadSchedules($event)" [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
          [rowsPerPageOptions]="[10,15,25,50,thrombolyticDecisionTotalRecords]"
          [globalFilterFields]="['UserName','FirstName','LastName','RoleName','Initials','UserLoginTime','IsActive']">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="TeleCareCase#" pResizableColumn style="width:9%">
                TeleCare Case #
                <p-sortIcon field="TeleCareCase#"></p-sortIcon>
              </th>
              <th pSortableColumn="Facility" pResizableColumn>
                Facility
                <p-sortIcon field="Facility"></p-sortIcon>
              </th>
              <th pSortableColumn="DateofConsult" pResizableColumn>
                Date of Consult
                <p-sortIcon field="DateofConsult"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationType" pResizableColumn>
                Identification Type
                <p-sortIcon field="IdentificationType"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationNumber" pResizableColumn>
                Identification Number
                <p-sortIcon field="IdentificationNumber"></p-sortIcon>
              </th>
              <th pSortableColumn="WorkFlowType" pResizableColumn>
                WorkFlow Type
                <p-sortIcon field="WorkFlowType"></p-sortIcon>
              </th>
              <th pSortableColumn="ThrombolyticDecisionInterval" pResizableColumn>
                Thrombolytic Decision Interval
                <p-sortIcon field="ThrombolyticDecisionInterval"></p-sortIcon>
              </th>
              <th pSortableColumn="InitialAssesment" pResizableColumn>
                Initial Assesment
                <p-sortIcon field="InitialAssesment"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-thrombolyticDecisionTimeList>
            <tr>
              <td>
                <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{thrombolyticDecisionTimeList.cas_case_number}}</ng-container>
                <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
                  <a [href]="accessCase + thrombolyticDecisionTimeList.cas_key + showPopupOnLoad" target="_blank">{{thrombolyticDecisionTimeList.cas_case_number}}</a>
                </ng-container>
              </td>
              <td>{{thrombolyticDecisionTimeList.Facility}}</td>
              <td>{{thrombolyticDecisionTimeList.DateofConsult}}</td>
              <td>{{thrombolyticDecisionTimeList.IdentificationType}}</td>
              <td>{{thrombolyticDecisionTimeList.cas_identification_number}}</td>
              <td>{{thrombolyticDecisionTimeList.WorkFlowType}}</td>
              <td>{{thrombolyticDecisionTimeList.ThrombolyticDecisionInterval}}</td>
              <td><ul class="intial-li"><li *ngFor="let initialAssesment of thrombolyticDecisionTimeList.Initial_Assesment">{{initialAssesment}}</li></ul></td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="thrombolyticDecisionTotalRecords==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="THROMBOLYTIC ADMINISTRATION TIME INTERVAL" class="relative">
        <!-- ////////////////////////////////////////THROMBOLYTIC ADMINISTRATION TIME INTERVAL////////////////////////////////////////////////// -->
        <div class="grid chartpdf-btnn justify-content-end">
          <p-button type="button" icon="pi pi-chart-line"
            (click)="showChart('THROMBOLYTIC ADMINISTRATION TIME INTERVAL')"
            [ngStyle]="showChartBool?{'pointer-events': 'none'} : {'pointer-events': 'all'}" [disabled]="showChartBool"
            label="Graph Outliers" class="p-button-primary mr-1"></p-button>
        </div>
        <p-table #dt [value]=" thrombolyticAdministrationTimeList" [rows]="rows"
          styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" sortMode="multiple" [lazy]="true"
          responsiveLayout="scroll" [rowHover]="true" dataKey="Id" (onLazyLoad)="lazyLoadSchedules($event)"
          [totalRecords]="thrombolyticAdministrationTotalRecords" [columns]="cols" [resizableColumns]="true" columnResizeMode="expand"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,15,25,50,thrombolyticAdministrationTotalRecords]">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="TeleCareCase#" pResizableColumn style="width:9%">
                TeleCare Case #
                <p-sortIcon field="TeleCareCase#"></p-sortIcon>
              </th>
              <th pSortableColumn="Facility" pResizableColumn>
                Facility
                <p-sortIcon field="Facility"></p-sortIcon>
              </th>
              <th pSortableColumn="DateofConsult" pResizableColumn>
                Date of Consult
                <p-sortIcon field="DateofConsult"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationType" pResizableColumn>
                Identification Type
                <p-sortIcon field="IdentificationType"></p-sortIcon>
              </th>
              <th pSortableColumn="IdentificationNumber" pResizableColumn>
                Identification Number
                <p-sortIcon field="IdentificationNumber"></p-sortIcon>
              </th>
              <th pSortableColumn="WorkFlowType" pResizableColumn>
                WorkFlow Type
                <p-sortIcon field="WorkFlowType"></p-sortIcon>
              </th>
              <th pSortableColumn="ThrombolyticAdministrationInterval" pResizableColumn>
                Thrombolytic Administration Interval
                <p-sortIcon field="ThrombolyticAdministrationInterval"></p-sortIcon>
              </th>
              <th pSortableColumn="InitialAssesment" pResizableColumn>
                Initial Assesment
                <p-sortIcon field="InitialAssesment"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-thrombolyticAdministrationTimeList>
            <tr>
              <td>
                <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{thrombolyticAdministrationTimeList.cas_case_number}}</ng-container>
                <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
                  <a [href]="accessCase + thrombolyticAdministrationTimeList.cas_key + showPopupOnLoad" target="_blank">{{thrombolyticAdministrationTimeList.cas_case_number}}</a>
                </ng-container>
              </td>
              <td>{{thrombolyticAdministrationTimeList.Facility}}</td>
              <td>{{thrombolyticAdministrationTimeList.DateofConsult}}</td>
              <td>{{thrombolyticAdministrationTimeList.IdentificationType}}</td>
              <td>{{thrombolyticAdministrationTimeList.cas_identification_number}}</td>
              <td>{{thrombolyticAdministrationTimeList.WorkFlowType}}</td>
              <td>{{thrombolyticAdministrationTimeList.ThrombolyticAdministrationInterval}}</td>
              <td><ul class="intial-li"><li *ngFor="let initialAssesment of thrombolyticAdministrationTimeList.Initial_Assesment">{{initialAssesment}}</li></ul></td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <h5 *ngIf="totalRecords==0" class="text-center create-roles">
                <b> No records found</b>
              </h5>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
      </span>
    </div>
  </div>
</div>

<!-- chart diaglog -->
<p-dialog [(visible)]="chartBool" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [style]="{width: '63vw'}"
  [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="header">
    <div class="grid savepdf-btn mt-1">
      <p-button type="button" id="savepdf" icon="pi pi-file-pdf" [loading]="loaders.value" (click)="exportPdf()"
        [loading]="exportPdfLoader" label="Save as PDF" class="p-button-primary mr-1"></p-button>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
   
    <div class="p-fluid formgrid">
      <div class="chart-popup bg-default px-3 pb-3" id="htmlData">
        <kendo-chart [seriesColors]="seriesColors">
          <kendo-chart-title
              [text]="chartsTitle"
              color="black"
              [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
              [align]="titleAlignment.align"
              [margin]="{ bottom: 40 }">
          </kendo-chart-title>
        
            <kendo-chart-legend position="bottom"
            [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
            </kendo-chart-legend>
        
          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="barChartCategories">
        
              <kendo-chart-category-axis-item-labels 
              font="bold 14px Arial, sans-serif" color="black" rotation="auto">
              </kendo-chart-category-axis-item-labels>
        
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>
        
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item [labels]="valueAxisLabels">
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>
        
          <kendo-chart-series>
            <kendo-chart-series-item [data]="barChartDatasets" [spacing]="0.25" [gap]="1"
            [name]="name" [color]="series.color" smooth="true"
            [labels]="seriesLabels"> 
          </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
        <!-- <p-chart class="QMSALLCHARTS" type="bar" [data]="activitationTimeIntervalData"
          [options]="activitationTimeIntervalDataOptions" [plugins]="lineChartPlugins"></p-chart> -->
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
      <button pButton type="button" (click)="hideChartDiaglog()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
  </ng-template>
</p-dialog>
